module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Time-Management.4176fa2d.jpg";